module.exports = __webpack_public_path__ + "static/media/avatar-6.8fabbe5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-6.png
// module id = 245
// module chunks = 0